import { ILookupHttpService, RemoteParams, LookupGridResult } from '@farris/ui-lookup';
import { Injectable } from '@angular/core';
import { HttpService } from '@ecp-caf/caf-common';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class WfReportDefHelpService implements ILookupHttpService {

  constructor(
    private http: HttpService
  ) {
  }

  getData(url: string, params?: RemoteParams): Observable<LookupGridResult> {
    const customData = params.customData;
    const index = params.pageIndex || 1;
    const size = params.pageSize || 20;
    const searchValue = JSON.parse(params.searchValue);
    if (searchValue.searchValue || customData.filter) {
      let query = '{';
      if (searchValue.searchValue) {
        if (searchValue.searchField === '*') {
          query += `"codeOrNameLike":"${searchValue.searchValue}",`;
        } else {
          query += `"${searchValue.searchField}":"${searchValue.searchValue}",`;
        }
      }
      if (customData.filter) {
        const keys = Object.keys(customData.filter);
        if (keys && keys.length > 0) {
          for (const key of keys) {
            if (customData.filter[key]) {
              query += `"${key}":"${customData.filter[key]}",`;
            }
          }
        }
      }
      if (query.substr(query.length - 1, 1) === ',') {
        query = query.substring(0, query.length - 1);
      }
      query += '}';
      query = encodeURIComponent(query);
      query += `&pageIndex=${index}&pageSize=${size}`;
      url += '?pageFilter=' + query;
    } else {
      url += `?pageIndex=${index}&pageSize=${size}`;
    }
    return this.http.get(url).pipe(
      map((re: any) => ({
        items: re.content,
        total: re.totalElements,
        pageInfo: {
          pageIndex: re.pageable.pageNumber + 1,
          pageSize: re.pageable.pageSize,
          pageList: [20, 40, 60, 80, 100],
          enablePager: true
        }
      }))
    );
  }
}
